// extracted by mini-css-extract-plugin
export default {"content":"SignWashPage_content__fE+R0","text":"SignWashPage_text__iCGSX","fiol":"SignWashPage_fiol__E6pX+","btn_container":"SignWashPage_btn_container__0UiUN"};